import { ComponentStyleConfig } from '@chakra-ui/react'

export const Heading: ComponentStyleConfig = {
    baseStyle: {
        color: `green.default`,
        fontFamily: 'Graphik',
    },
    variants: {
        'display-xl': {
            fontFamily: 'Deacon',
            fontWeight: 900,
            fontSize: '4.875rem',
            lineHeight: '4.5rem',
            letterSpacing: '-1.5%',
        },
        'display-l': {
            fontFamily: 'Deacon',
            fontWeight: 900,
            fontSize: '3.1875rem',
            lineHeight: '3.5625rem',
            letterSpacing: '-1.5%',
        },
        'heading-xl': {
            fontWeight: 400,
            fontSize: '2.25rem',
            lineHeight: '2.5625rem',
        },
        'heading-l': {
            fontWeight: 400,
            fontSize: '1.6875rem',
            lineHeight: '2.0625rem',
        },
        'heading-m': {
            fontWeight: 400,
            fontSize: '1.3125rem',
            lineHeight: '1.6875rem',
        },
        'heading-s': {
            fontWeight: 400,
            fontSize: '1.125rem',
            lineHeight: '1.5rem',
        },
        'heading-xs': {
            fontWeight: 400,
            fontSize: '0.9375rem',
            lineHeight: '1.4375rem',
        },
        'heading-xxs': {
            fontWeight: 400,
            fontSize: '0.75rem',
            lineHeight: '1.125rem',
        },
    },
    defaultProps: {
        variant: 'heading-m',
    },
}
